/* unplugin-vue-components disabled */import script from "./SubTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SubTab.vue?vue&type=script&setup=true&lang=js"

import "./SubTab.vue?vue&type=style&index=0&id=4e1619d7&lang=scss"

const __exports__ = script;

export default __exports__